import React from "react";
import {
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  TextField,
  Alert,
  Autocomplete,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import OrgConfig from "./OrgConfig";
import { EventContext } from "../../../contexts/EventContext";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const NewOrgDialog = ({ open, close, org }) => {
  const { userData } = React.useContext(EventContext);
  const [adminUsers, setAdminUsers] = React.useState([]);
  const [orgName, setOrgName] = React.useState("");
  const [error, setError] = React.useState(null);
  const [owner, setOwner] = React.useState(null);
  const [organizerId, setOrganizerId] = React.useState("");
  const [siteUrl, setSiteUrl] = React.useState("");
  const [eventbriteOrganizationId, setEventbriteOrganizationId] =
    React.useState("");
  const [eventbriteOrganizerId, setEventbriteOrganizerId] = React.useState("");
  const [config, setConfig] = React.useState({});

  React.useEffect(() => {
    if (org) getConfig();
    try {
      setOrgName(org?.name || "");
      setEventbriteOrganizationId(org?.eventbriteOrganizationId || "");
      setEventbriteOrganizerId(org?.eventbriteOrganizerId.join(", ") || "");
    } catch (e) {}
  }, [org]);

  const getConfig = async () => {
    const result = await request(`orgs/config/?orgId=${org._id}`);
    if (result.success) {
      setConfig(result.config);
    }
  };

  const handleSave = async () => {
    const { _id: id, ...c } = config;
    delete c._id;
    const body = { orgId: org._id, configId: id, config: c };
    const result = await request("orgs/updateconfig", "post", body);
    if (result.success) {
      toast.success("Configuration updated");
    }
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={close}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={close}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {org ? "Edit Org" : "New Org"}
            </Typography>
            <Button autoFocus color="inherit" onClick={handleSave}>
              save
            </Button>
          </Toolbar>
        </AppBar>
        <Grid container direction="column" spacing={3} style={{ padding: 20 }}>
          {error ? (
            <Grid item>
              <Alert severity="error">{error}</Alert>
            </Grid>
          ) : (
            <></>
          )}
          <Grid item>
            <TextField
              fullWidth
              label="Org Name"
              value={orgName}
              onChange={(e) => setOrgName(e.target.value)}
              disabled={userData?.role === "superadmin" ? false : true}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="Eventbrite Organization ID"
              value={eventbriteOrganizationId}
              disabled={true}

              // onChange={(e) => setEventbriteOrganizationId(e.target.value)}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="Eventbrite Organizer IDs"
              value={eventbriteOrganizerId}
              disabled={true}
              // onChange={(e) => setOrganizerId(e.target.value)}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="SMS Number"
              value={config?.smsNumber || ""}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <OrgConfig
              config={config}
              onChange={(settings) => setConfig({ ...settings })}
            />
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              onClick={handleSave}
              style={{ width: "100%" }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export default NewOrgDialog;
